import axiosInstance from "@/utils/AxiosInstance";
import {QuantityTableType} from "@/services/prices/entities/QuantityTableType";

const BASE_API = '/prices';

const getQuantityTableTypes = async (): Promise<any> => {
    return await axiosInstance.get(`${BASE_API}/`);
}

const updateQuantityTablePrices = async (body: QuantityTableType[]): Promise<any> => {
    return await axiosInstance.put(`${BASE_API}/`, body);
}

export default {
    getQuantityTableTypes,
    updateQuantityTablePrices,
}